var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ preview: !_vm.inline, btn: _vm.inline }},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.click($event)}}},[_vm._v(_vm._s(_vm.label))]),_c('form',{ref:"form"})])}
var staticRenderFns = []

export { render, staticRenderFns }